module.exports = {"150928105":"白音察干镇","150928106":"察哈尔右翼后旗土牧尔台镇","150928107":"察哈尔右翼后旗红格尔图镇","150928108":"察哈尔右翼后旗贲红镇","150928109":"察哈尔右翼后旗大六号镇","150928209":"察哈尔右翼后旗当郎忽洞苏木","150928210":"察哈尔右翼后旗乌兰哈达苏木","150928211":"察哈尔右翼后旗锡勒乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150928.json
// module id = 428
// module chunks = 0